import {
    Component, Input, Output, EventEmitter,
    OnDestroy, OnChanges, SimpleChange
} from '@angular/core';
import { Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { SampleTrackingSelectFilterService } from './sample-tracking-select-filter-service';

export interface IFilterSelectItem {
    id: number;
    value: string;
    checked?: boolean;
    key?: string;
    sponsorName?: string;
    sortId?: any;
    subValue?: string;
    enableShippedToFilter?: boolean;
    isQuickFilterEnabled?: boolean;
    enableReturnTypeFilter?: boolean;
    filterByPatient?: { id: number, value: string };
    timeFrameLabel?: string;
    helpText?: string;
    viewName?: string;
    disclaimerText?: string;
    isMissMatchIconAppear?: boolean;
}

@Component({
    selector: 'sample-tracking-select',
    template: require('./sample-tracking-select.component.html'),
    styles: [require('./sample-tracking-select.component.scss')]
})
export class SampleTrackingSelectComponent implements OnChanges, OnDestroy {

    @Input()
    public list: IFilterSelectItem[];

    @Input()
    public multiSelect = true;

    @Input()
    public disabled = false;

    @Input()
    public defaultValue: IFilterSelectItem[];

    @Input()
    public isCloseDisabled: false;

    @Input()
    public defaultItemText: string;

    @Output()
    public onFilterChange = new EventEmitter();

    public checkedList: IFilterSelectItem[];
    public filterItems: IFilterSelectItem[];
    public currentSelected: {};
    public showDropDown = false;
    private subscription: Subscription;

    constructor(private selectFilterService: SampleTrackingSelectFilterService) {

        this.subscription = this.selectFilterService.clearFilters$.subscribe(
            mission => {
                if (mission) {
                    this.clearSelection(true);
                }
            });
    }

    public ngOnChanges() {
        const selectedItems = this.defaultValue ? this.defaultValue : [];
        this.checkedList = selectedItems ? selectedItems : [];
        if (!this.list || this.list.length === 0) {
            this.defaultItemText = this.defaultItemText ? this.defaultItemText : 'None';
        }
        if (this.disabled) { return; }
        if (this.list && this.list.length > 0) {
            this.defaultItemText = this.defaultItemText && this.defaultItemText !== 'None' ? this.defaultItemText : 'All';
            this.list.forEach(data => data.checked = false);
            let toRemoveList: IFilterSelectItem[] = [];
            this.checkedList.forEach(item => {
                let index = this.list.findIndex(t => t.id === item.id);
                if (index !== -1) {
                    this.list[index].checked = true;
                } else {
                    toRemoveList.push(item);
                }

            });
            if (toRemoveList && toRemoveList.length > 0) {
                let filteredList = this.checkedList;
                filteredList.forEach(item => {
                    let index = toRemoveList.findIndex(t => t.id === item.id);
                    if (index !== -1) {
                        this.checkedList = this.checkedList.filter(t => t.id !== item.id);
                    }
                });
            }
            this.filterItems = this.list;
        } else {
            this.list = [];
            this.filterItems = [];
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public getSelectedValue(item: IFilterSelectItem) {
        if (item.checked) {
            this.checkedList.push(item);
        } else {
            this.checkedList = this.checkedList.filter(cl => cl.id !== item.id);
        }

        this.currentSelected = { item };

        this.onFilterValueChange();
    }

    public onsingleValueSelect(item: IFilterSelectItem) {
        this.filterItems.forEach(t => t.checked = false);
        this.checkedList = [];
        item.checked = !item.checked;
        if (item.checked) {
            this.checkedList.push(item);
        }

        this.currentSelected = { item };

        this.onFilterValueChange();
    }

    public mouseLeave($event: Event) {
        this.showDropDown = false;
    }

    public unCheck(item: IFilterSelectItem) {
        item.checked = false;
        this.checkedList = this.checkedList.filter(cl => cl.id !== item.id);
        this.onFilterValueChange();
    }

    public onFilterValueChange() {
        this.onFilterChange.emit(this.checkedList);
    }

    public clearSelection(skipEmit = false) {
        this.showDropDown = false;
        if (this.filterItems) {
            for (var item of this.filterItems) {
                item.checked = false;
            }
        }
        this.defaultValue = this.disabled ? this.defaultValue : [];
        this.checkedList = this.disabled && this.defaultValue && this.defaultValue.length > 0 ? this.defaultValue : [];
        if (!skipEmit) {
            this.onFilterValueChange();
        }
    }

    public getToolTip(checkedList: IFilterSelectItem[]) {
        if (!checkedList || checkedList.length < 1) { return ''; }
        return checkedList.slice(1).map(item => '  ' + item.value);
    }

    public onSearchBoxChange(searchText: string) {
        this.filterItems = this.list.filter(item => item.value.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }
}